import * as angular from "angular";
import * as _ from "lodash";

angular
  .module('bringoz.admin.commons')
  .filter('bringozPrice', bringozPrice);

function bringozPrice($filter, splitService) {
  return function bringozPriceFilter(price, defaultValue, currencyCode, fullPrecision) {

    if (_.isUndefined(price)) {
      return _.isUndefined(defaultValue) ? '--' : defaultValue;
    }

    const currency = currencyCode || splitService.getCurrencyCode();
    const fraction = fullPrecision ? _.get(price.toString().split('.'), '[1].length', 0) : undefined;
    return $filter('isoCurrency')(price, currency, fraction);
  }
}
